import { useMediaQuery } from 'react-responsive';
export const KEY_DEVICE = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
  ALL: 'all'
};
export const useDevice = (_type) => {
  switch (_type) {
    case KEY_DEVICE.DESKTOP: return useMediaQuery({ query: '(min-width: 769px)' });
    case KEY_DEVICE.MOBILE: return useMediaQuery({ query: '(max-width: 768px)' });
    case KEY_DEVICE.ALL: return true;
    default: return useMediaQuery({ query: '(min-width: 768px)' });
  }
};
